import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { jwtDecode } from "jwt-decode";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().authSlice.token;
    const lang = getState().language?.lang;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    headers.set("Accept-Language", lang);
    return headers;
  },
});

export const baseQueryWithAuth = async (args, api, extraOptions) => {
  const token = api.getState().authSlice.token;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) {
        handleLogout(api);
        return { error: { status: 401, message: "Token expired" } };
      }
    } catch (err) {
      console.error("Failed to decode token", err);
      handleLogout(api);
      return { error: { status: 401, message: "Invalid token" } };
    }
  }

  const result = await rawBaseQuery(args, api, extraOptions);

  if (result?.error) {
    const status = result.error.status;
    const message = result.error.data?.message?.toLowerCase() || "";

    if (
      status === 401 ||
      (status === 500 && message.includes("failed to authenticate token"))
    ) {
      handleLogout(api);
    }
  }

  return result;
};

function handleLogout(api) {
  api.dispatch({ type: "authSlice/logout" });
  localStorage.removeItem("persist:root");
  window.location.href = "/";
}
